import {
  animate,
  AUTO_STYLE,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  ContentChild,
  Input,
  OnDestroy,
  TemplateRef,
} from '@angular/core';
import { Subject } from 'rxjs';

import { AccordionContentDirective } from './accordion-content.directive';
import { AccordionTitleDirective } from './accordion-title.directive';

let uniqueId = 0;

@Component({
  selector: 'ps-ui-accordion-section',
  templateUrl: 'accordion-section.component.html',
  styleUrls: ['accordion-section.component.css'],
  animations: [
    trigger('collapse', [
      transition(':enter', [
        style({ height: '0', 'overflow-y': 'hidden' }),
        animate(
          '0.3s ease-in-out',
          style({ height: AUTO_STYLE, 'overflow-y': AUTO_STYLE })
        ),
      ]),
      transition(':leave', [
        animate(
          '0.3s ease-in-out',
          style({ height: '0', 'overflow-y': 'hidden' })
        ),
      ]),
    ]),
  ],
})
export class AccordionSectionComponent implements OnDestroy {
  /** The accordion title. You can use psUiAccordionTitleContent if you need more control */
  @Input() title?: string;
  /** If true the accordion section cannot be expanded */
  @Input() disabled = false;
  /** An optional id for the section that must be unique to the page */
  @Input() id = `ps-ui-accordion-item-${uniqueId++}`;
  /** New property for tooltip text */
  @Input() tooltipText?: string;

  private _isExpanded = false;
  /** If true the section will start out expanded */
  @Input() set isExpanded(isExpanded: boolean) {
    this._isExpanded = isExpanded;
    this._segmentToggled.next(this._isExpanded);
  }
  get isExpanded(): boolean {
    return this._isExpanded;
  }

  private _segmentToggled = new Subject<boolean>();
  segmentToggled = this._segmentToggled.asObservable();

  /** Lazy loaded template that's wrapped in ng-template tags and using the psUiAccordionContent directive */
  @ContentChild(AccordionContentDirective, { read: TemplateRef, static: true })
  templateContent: TemplateRef<any> | null = null;

  @ContentChild(AccordionTitleDirective, { read: TemplateRef, static: true })
  titleContent: TemplateRef<any> | null = null;

  arrowToggleOnly = false;

  constructor() {}

  toggle(event: Event, isChevron = false) {
    event.stopPropagation();
    if (!this.arrowToggleOnly) {
      this.isExpanded = !this.isExpanded;
      return;
    }

    if (this.arrowToggleOnly && isChevron) {
      this.isExpanded = !this.isExpanded;
    }
  }

  open() {
    this.isExpanded = true;
  }

  close() {
    this.isExpanded = false;
  }

  ngOnDestroy(): void {
    // Ensure observables complete so parent component can unsubscribe
    this._segmentToggled.next();
    this._segmentToggled.complete();
  }
}
